<template>
    <div>
        <!--show card only if loading is not in progress-->
        <page-card :header="$t('pages.pin.title')" v-if="!loading">
            <generic-notification :notifications.sync="notifications"></generic-notification>

            <!--if there is no pin, show a warning-->
            <callout callout-class="callout-info" icon="info" v-if="!isset">
                {{ $t('pages.pin.pin_not_set') }}
            </callout>

            <!--if there is a pin show it and allow user to refresh-->
            <b-form v-if="isset">
                <b-form-group :label="$t('pages.pin.pin_field_current')" label-for="frmPinChangePin">
                    <b-input-group>
                        <b-form-input :type="pinVisible ? 'text' : 'password'"
                                      id="frmPinChangePin"
                                      placeholder=""
                                      v-model="pin"
                                      disabled>
                        </b-form-input>

                        <b-input-group-append>
                            <b-button variant="primary" :pressed.sync="pinVisible">
                              <b-icon-eye-slash v-if="pinVisible" aria-hidden="true"/>
                              <b-icon-eye v-else aria-hidden="true"/>
                              <template v-if="pinVisible">
                                  {{ $t('pages.pin.hide') }}
                              </template>
                              <template v-else>
                                  {{ $t('pages.pin.show') }}
                              </template>
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-form>

            <b-button-group>
                <b-button v-b-modal.modalConfirmRefreshPin variant="primary">
                    <b-icon-arrow-clockwise aria-hidden="true"/>
                    {{ $t('pages.pin.pin_refresh') }}
                </b-button>
                <b-button v-b-modal.modalConfirmRemovePin variant="danger">
                    <b-icon-trash aria-hidden="true"/>
                    {{ $t('pages.pin.pin_remove') }}
                </b-button>
            </b-button-group>
        </page-card>

        <!--modal for refreshing the pin-->
        <b-modal id="modalConfirmRefreshPin"
                 :title="$t('common.confirmation')"
                 title-tag="h3"
                 :ok-title="$t('common.yes')"
                 :cancel-title="$t('common.cancel')"
                 @ok="refreshPin">
            {{ $t('pages.pin.confirm') }}
        </b-modal>
        <!--modal for removing the pin-->
        <b-modal id="modalConfirmRemovePin"
                 :title="$t('common.confirmation')"
                 title-tag="h3"
                 :ok-title="$t('common.yes')"
                 :cancel-title="$t('common.cancel')"
                 @ok="removePin">
            {{ $t('pages.pin.confirm_removal') }}
        </b-modal>
    </div>
</template>

<script>
import GenericNotification from "../layout/GenericNotification";
import Callout from "../layout/Callout";
import PageCard from "../layout/PageCard";
import LoadingInjector from "../../mixins/LoadingInjector";

export default {
    mixins: [
        LoadingInjector
    ],
    components: {
        PageCard,
        Callout,
        GenericNotification,
    },
    props: {
        rzaccount: {
            required: true,
            type: String,
        }
    },
    data() {
        return {
            pin: '',
            pinVisible: false,
            isset: false,
            loading: true,
            notifications: [],
        }
    },
    created() {
        this.errorHandler = this.$shared.errorHandler;

        this.$Echo.private(`rz-account.${this.rzaccount}`)
            .listen('BolognaEvent', (e) => {
                this.notifications.push(e);
                switch (e.name) {
                    case "AttributeChangeSuccessful": {
                        this.pin = this.$purify.sanitize(e.load.value);
                        this.isset = true;
                        break;
                    }
                    case "AttributeChangeFailed": {
                        this.retrievePin();
                        break;
                    }
                    case "AttributeRemovalSuccessful": {
                        this.isset = false;
                        break;
                    }
                    case "AttributeRemovalFailed": {
                        this.isset = false;
                        break;
                    }
                }
            });
    },
    mounted() {
        console.log('Mounted PinChange.');
        this.retrievePin();
    },
    methods: {
        switchVisibility: function () {
            this.pinVisible = !this.pinVisible;
        },
        refreshPin: function () {
            this.isset = false;
            this.loading = true;
            this.axios.post(this.$Bologna.secure_url(`/v1/accounting/pin/${this.rzaccount}`), {})
                .then(response => {})
                .catch(err => {
                    this.errorHandler(err);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        removePin: function () {
            this.isset = false;
            this.axios.delete(this.$Bologna.secure_url(`/v1/accounting/pin/${this.rzaccount}`), {
                data: {}
                }).then(response => {})
                .catch(err => {
                    this.errorHandler(err);
                });
        },
        retrievePin: function () {
            this.loading = true;
            this.axios.get(this.$Bologna.secure_url(`/v1/accounting/pin/${this.rzaccount}`))
                .then(response => {
                    this.isset = response.data.data.isset;
                    this.pin = this.$purify.sanitize(response.data.data.value);
                })
                .catch(err => {
                    console.log(this.$shared.errorHandlerForResponder(err));
                })
                .finally(()=>{this.loading=false});
        }
    }
};
</script>
